import React from "react";
import { Tabs } from "@mantine/core";
import { useTranslation } from "react-i18next";
import Income from "./Shipping";
import Labels from "./labels/Shipping";
import { Helmet } from "react-helmet";

const IncomeTabs = () => {

  const [_] = useTranslation("global");

  return (
    <Tabs defaultValue="gallery" className="w-100">
    
      <Tabs.List grow>  <Helmet>
    <title>{_("panel.imports")}</title> 
 </Helmet>
        <Tabs.Tab value="gallery" className="fs-5" color="rgb(89, 198, 201)">
          {_("panel.imports")}
        </Tabs.Tab>
        <Tabs.Tab value="messages" className="fs-5" color="rgb(89, 198, 201)">
          {_("panel.labels")}
        </Tabs.Tab>
      </Tabs.List>

      <Tabs.Panel value="gallery">
        <Income />
      </Tabs.Panel>

      <Tabs.Panel value="messages">
        <Labels />
      </Tabs.Panel>
    </Tabs>
  );
};

export default IncomeTabs;
